import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // Initialize i18n
// Self-hosted Inter (ticket 5) — replaces the former Google Fonts CDN
// stylesheet so the app makes no third-party requests.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

